'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentsComponent = require('../../components/Component');

var _componentsComponent2 = _interopRequireDefault(_componentsComponent);

var _components = {
	_$RowItems: {
		displayName: 'RowItems'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var RowItems = (function (_Component) {
	_inherits(RowItems, _Component);

	function RowItems() {
		_classCallCheck(this, _RowItems);

		_Component.apply(this, arguments);
	}

	RowItems.prototype.render = function render() {
		var items = this.props.data.get('items').toJS().map(function (item) {
			return _react2['default'].createElement(
				'tr',
				{ key: item.id },
				_react2['default'].createElement(
					'td',
					null,
					item.title
				),
				_react2['default'].createElement(
					'td',
					{ style: { textAlign: 'right', width: 60 } },
					item.amount
				),
				_react2['default'].createElement(
					'td',
					{ style: { textAlign: 'right', width: 60 } },
					item.price
				)
			);
		});
		return _react2['default'].createElement(
			'table',
			{ className: 'detail', style: { width: 600 } },
			_react2['default'].createElement(
				'thead',
				null,
				_react2['default'].createElement(
					'tr',
					null,
					_react2['default'].createElement(
						'th',
						null,
						'Popis'
					),
					_react2['default'].createElement(
						'th',
						null,
						'Počet'
					),
					_react2['default'].createElement(
						'th',
						null,
						'Cena'
					)
				)
			),
			_react2['default'].createElement(
				'tbody',
				null,
				items
			)
		);
	};

	var _RowItems = RowItems;
	RowItems = _wrapComponent('_$RowItems')(RowItems) || RowItems;
	return RowItems;
})(_componentsComponent2['default']);

exports['default'] = RowItems;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Invoice/RowItems.js
 ** module id = 503
 ** module chunks = 2
 **/